import { Box, Stack, Typography } from '@mui/material'
import { MapPin } from 'lucide-react'
import { contact } from '@/content/site'
import { colors } from '@/theme'

/**
 * Google Map embed. Disabled until an official location is provided
 * (contact.mapsEnabled). Renders a branded placeholder in the meantime, so the
 * layout is final and only the config needs to change to go live.
 */
export function MapEmbed() {
  if (contact.mapsEnabled && contact.mapEmbedUrl) {
    return (
      <Box
        component="iframe"
        src={contact.mapEmbedUrl}
        title="True Forge location"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        sx={{ width: '100%', height: { xs: 320, md: 420 }, border: 0, display: 'block' }}
      />
    )
  }

  return (
    <Box
      sx={{
        width: '100%',
        height: { xs: 260, md: 360 },
        bgcolor: colors.surfaceAlt,
        border: `1px dashed ${colors.borderStrong}`,
        borderRadius: 1,
        display: 'grid',
        placeItems: 'center',
      }}
    >
      <Stack alignItems="center" spacing={1.5} sx={{ color: 'text.secondary' }}>
        <MapPin size={28} />
        <Typography variant="overline">Map available once location is confirmed</Typography>
      </Stack>
    </Box>
  )
}
